// src/components/ImageModal.js
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

function ImageModal({ image, name, onClose }) {
    const [isZoomed, setIsZoomed] = useState(false);
    const [origin, setOrigin] = useState({ x: 50, y: 50 });

    // Close on ESC
    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden"; // lock page scroll
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [onClose]);

    const toggleZoom = (e) => {
        e.stopPropagation();
        setIsZoomed((z) => !z);
    };

    const handleOverlayMouseMove = (e) => {
        if (!isZoomed) return;
        const rect = e.currentTarget.getBoundingClientRect();
        setOrigin({
            x: ((e.clientX - rect.left) / rect.width) * 100,
            y: ((e.clientY - rect.top)  / rect.height) * 100
        });
    };

    const modalUI = (
        <div className="overlay" onClick={onClose} role="dialog" aria-modal="true">
            <button className="close-button" onClick={onClose}>Close</button>
            <div
                className="overlay-content"
                onMouseMove={handleOverlayMouseMove}
                onClick={(e) => e.stopPropagation()}
            >
                <img
                    src={image}
                    alt={name}
                    className="overlay-image"
                    onClick={toggleZoom}
                    style={{
                        transform: isZoomed ? "scale(2)" : "scale(1)",
                        transformOrigin: `${origin.x}% ${origin.y}%`,
                        transition: "transform 0.3s ease, transform-origin 0.3s ease",
                        cursor: isZoomed ? "move" : "zoom-in"
                    }}
                />
            </div>
        </div>
    );

    // Render to <body> to avoid any clipping/stacking from parents
    return createPortal(modalUI, document.body);
}

export default ImageModal;
